import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';

const AuditLogsTopNav = () => {
  return(
    <div className="topbar -admin-subnav -analytics">
      <div className="yt-container">
        <ul className="navigation -left">
          <li><small><em>Audit Logs:</em></small></li>
          <li><NavLink to="/admin/audit-logs/user" activeClassName="active">Users</NavLink></li>
          <li><NavLink to="/admin/audit-logs/group-user" activeClassName="active">Program Permissions</NavLink></li>
          <li><NavLink to="/admin/audit-logs/module-certificate" activeClassName="active">Certificates</NavLink></li>
          <li className="-pipe"/>
          <li><NavLink to="/admin/audit-logs/group" activeClassName="active">Programs</NavLink></li>
          <li><NavLink to="/admin/audit-logs/group-role" activeClassName="active">Roles</NavLink></li>
          <li><NavLink to="/admin/audit-logs/sponsor" activeClassName="active">Sponsors</NavLink></li>
          <li><NavLink to="/admin/audit-logs/scene" activeClassName="active">Scenes</NavLink></li>
          <li><NavLink to="/admin/audit-logs/certificate-template" activeClassName="active">Certificate Templates</NavLink></li>
          <li><NavLink to="/admin/audit-logs/content-module" activeClassName="active">Content Modules</NavLink></li>
          {/* <li><NavLink to="/admin/audit-logs/sentiment-question" activeClassName="active">Sentiment Questions</NavLink></li> */}
        </ul>
      </div>
    </div>
  )
}

export default withRouter(AuditLogsTopNav);



// WEBPACK FOOTER //
// modules/admin/components/AuditLogsTopNav.js.jsx